import React from 'react';
import { Upload, Scissors, PackageCheck } from 'lucide-react';
import GenericSectionDashboard from '../GenericSectionDashboard';

const SampleDashboard = () => {
  const customTiles = [
    {
      id: 'sample-pick-slip-upload',
      title: 'Pick Slip Upload',
      description: 'Upload sample pick slips for cutting',
      icon: Upload,
      iconBg: 'bg-indigo-600',
      route: '/sections/sample/pick-slip-upload',
      testId: 'sample-pick-slip-upload-tile',
      priority: true,
    },
    {
      id: 'sample-cutting-station',
      title: 'Cutting Station',
      description: 'Process sample cutting against pick slips',
      icon: Scissors,
      iconBg: 'bg-amber-600',
      route: '/sections/sample/cutting-station',
      testId: 'sample-cutting-station-tile',
      priority: true,
    },
    {
      id: 'sample-full-packing',
      title: 'Full Sample Packing',
      description: 'Pack full-unit samples for dispatch',
      icon: PackageCheck,
      iconBg: 'bg-emerald-600',
      route: '/sections/sample/full-sample-packing',
      testId: 'sample-full-packing-tile',
      priority: true,
    },
  ];

  return (
    <GenericSectionDashboard
      sectionName="Sample Section"
      sectionId="sample"
      sectionKey="Sample"
      description="Sample Management & Tracking"
      backRoute="/"
      customTiles={customTiles}
    />
  );
};

export default SampleDashboard;
